module.exports = __webpack_public_path__ + "img/keyv_left_3_1000.2e7f8d2c.jpg";